/**
* stylebook/js/style.js
*
* 1. STYLE BOOK内のJSの処理はこのファイルに全て記述し、まとめて管理してください。
* 2. STYLE BOOK以外の要素への影響を防ぐため、必ずセレクタに「#style_book」を親として記述してください。
*
*/

$(function(){

	/****************************************************************************
	* 配置した要素のレイアウトを整列
	****************************************************************************/
	/*$('#style_book .grid').masonry({
		columnWidth: 160
	});*/

	/****************************************************************************
	* クリック後のポップアップの高さ調整
	* ---------------------------------------------------------------------------
	* .lightbox-layout：ポップアップ要素
	****************************************************************************/
	stylebookLightboxHeight();

	//リサイズ時
	$(window).resize(function () {
		stylebookLightboxHeight();
	});
	
	/****************************************************************************
	* ボタン押下で要素を展開
	* ---------------------------------------------------------------------------
	* .js-toggle-link：展開ボタン
	* .js-toggle-box：展開させる要素
	****************************************************************************/
	$("#style_book .js-toggle-link").on("click",function(){
		$('#style_book .js-toggle-box').slideToggle('slow');
	});

});

/****************************************************************************
* クリック後のポップアップの高さ調整
****************************************************************************/
function stylebookLightboxHeight(){
	hsize = $(window).height();
	hsize = hsize - 60;
	$("#style_book .lightbox-layout").css("height", hsize + "px");
}
